import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { HashRouter } from 'react-router-dom'
import './index.css';
import 'antd/dist/antd.min.css';
import 'animate.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import i18n from "./utils/language/i18n";

let language = localStorage.getItem('language')|| navigator.language;
i18n.changeLanguage(language);
localStorage.setItem("language", language)
document.documentElement.setAttribute("data-lang", language);

const root = ReactDOM.createRoot(
  document.getElementById('root')
);
root.render(
  <HashRouter>
    <Suspense>
      <App />
    </Suspense>
  </HashRouter>
);

reportWebVitals();
